import { useMutation } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import eventsApi from '../api/events.api';
import { QualityEventCreate } from '../types/qualityEvent';
import { DefaultErrorMessage } from '../displayStrings';
import { AxiosError } from 'axios';
import { extractMessageFromError } from '../utils/errorUtils';

export const useCreateEvent = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  return useMutation((payload: QualityEventCreate) => eventsApi.createViaMedtech(companyId, payload), {
    onError: (error: AxiosError) => {
      const errorMessage = extractMessageFromError(error);
      const message = error?.response?.status === 400 ? errorMessage : DefaultErrorMessage;
      showToast({
        title: 'Event not created',
        description: message,
        status: 'error',
      });
    },
  });
};
